import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × JACQUEMUS: Provencal minimalism meets op-art order
// Sand gradients, micro geometry, beige/pastel lattice
export function VasarelyJacquemusMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="jacquemus-sand" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F5E6D3" />
          <stop offset="30%" stopColor="#E8D5BD" />
          <stop offset="70%" stopColor="#D4C4A8" />
          <stop offset="100%" stopColor="#C9B896" />
        </linearGradient>
        <radialGradient id="jacquemus-sun">
          <stop offset="0%" stopColor="#FFF4E0" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#FFE4B5" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Sand background */}
      <rect x="0" y="0" width="794" height="1123" fill="url(#jacquemus-sand)" />

      <g transform="translate(397 540)">
        {/* Micro geometry lattice */}
        {Array.from({ length: 30 }).map((_, i) =>
          Array.from({ length: 40 }).map((_, j) => {
            const x = (i - 14.5) * 25;
            const y = (j - 19.5) * 26;
            
            return (
              <circle
                key={`${i}-${j}`}
                cx={x}
                cy={y}
                r="3"
                fill="none"
                stroke="#D4C4A8"
                strokeWidth="0.5"
                opacity="0.4"
              />
            );
          })
        )}

        {/* Beige pastel lattice */}
        {Array.from({ length: 10 }).map((_, i) =>
          Array.from({ length: 14 }).map((_, j) => {
            const x = (i - 4.5) * 70;
            const y = (j - 6.5) * 70;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 30}
                y={y - 30}
                width="60"
                height="60"
                fill="none"
                stroke="#C9B896"
                strokeWidth="1"
                opacity="0.25"
              />
            );
          })
        )}

        {/* Provencal sun rays */}
        {Array.from({ length: 16 }).map((_, i) => {
          const angle = (i * Math.PI) / 8;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 300}
              y2={Math.sin(angle) * 300}
              stroke="#E8D5BD"
              strokeWidth="1"
              opacity="0.2"
            />
          );
        })}

        {/* Warm rationality circles */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 40 + i * 24;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#D4C4A8"
              strokeWidth="1.5"
              opacity={0.35 - i * 0.025}
            />
          );
        })}

        {/* Central sun */}
        <circle cx="0" cy="0" r="100" fill="url(#jacquemus-sun)" />
        <circle cx="0" cy="0" r="80" fill="none" stroke="#FFF4E0" strokeWidth="2" opacity="0.6" />
        <circle cx="0" cy="0" r="60" fill="none" stroke="#FFE4B5" strokeWidth="1.5" opacity="0.5" />

        {/* Minimalist accents */}
        {[0, 90, 180, 270].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 150;
          
          return (
            <rect
              key={angle}
              x={Math.cos(rad) * r - 15}
              y={Math.sin(rad) * r - 15}
              width="30"
              height="30"
              fill="#C9B896"
              opacity="0.4"
            />
          );
        })}
      </g>

      {/* Provencal minimalism */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="sans-serif" fontSize="10" fill="#C9B896" letterSpacing="3">
        rationalité chaleureuse
      </text>
    </g>
  );
}
